//
// Note: The transition to the new chart feed will be gradual using the feature flag below. Once
// all practices have transitioned to the new chart feed, the feature flag will be removed.
//
// Pratices with PLR functionality will be required to have the new chart feed enabled.
//
// TODO NewChartFeed: after transition remove unneeded params i.e. feedDate, buttonsInfo.
// Note: that a similar branch for the new templates are in reqActRenderer.js
//
goog.provide('el8.appchart.mainFeeds.chartRenderer');

goog.require('el8.appchart.mainFeeds.actions');
goog.require('el8.appchart.mainFeeds.chartFeedReactRenderMap');
goog.require('el8.appchart.mainFeeds.plrNotification');
goog.require('el8.appchart.permissions');
goog.require('el8.data.base');
goog.require('el8.model.base');
goog.require('el8.ptdata.plrCollaborators');
goog.require('el8.ptdata.fetch');
goog.require('el8.ptdata.model.note.asSoyMap');

goog.require('el8.template.render.chartFeedItem');
goog.require('el8.template.render.chartFeedItem.visitNoteContent');

goog.require('el8.template.render.chartFeedItemNew');
goog.require('el8.template.render.chartFeedItemNew.plr');
goog.require('el8.template.render.chartFeedItemNew.visitNoteContent');

goog.require('el8.util.datecompare');

goog.require("el8.model.identify");

function convertLinks(html) {
    function maybeAddProtocol(string) {
        if (!string.includes('http')){
            return "http://" + string
        } else {
            return string
        }
    }
    var regex = /((https?)(:\/\/))?(www\.)([^\s<>]+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/g;
    function link(value) {
        return '<a href="' + maybeAddProtocol(value) + '" target="_blank" rel="noopener">' + value + '</a>'
    };

    return $(html).html($(html).html().replace(regex, link))
}

el8.appchart.mainFeeds.chartRenderer = function(item, indexedItem) {

    // `item` will not exist for React-rendered feed items, so we fall back
    // to `indexedItem`'s model class in that case. We do not want to just always
    // use `indexedItem.model_class` because that *also* may not exist in certain
    // code paths, such as `el8.appchart.mainFeeds.ChartFeedRenderer.prototype.addPreview`,
    // which fakes the `indexedItem` but does a half-baked job of it, defining the `id`
    // field but omitting everything else.
    //
    // Just check both of these things, because nothing can be trusted in legacy.
    // (╯°□°)╯︵ ┻━┻
    var mClass = item ? item.getModelClass() : indexedItem.model_class;

    var _templateBase = el8.template.render.chartFeedItemNew;

    if (!item) {
        var shouldRenderReactContainer = Boolean(el8.appchart.mainFeeds.chartFeedReactRenderMap[mClass]);
        if (shouldRenderReactContainer) {
            return function(item, feedId) {
                return _templateBase.reactItem({
                    feedId: feedId,
                    mClass: mClass
                });
            };  
        } else {
            console.warn('chartRenderer called with no `item` but no React renderer exists for model class: ' + mClass);
            return null;
        }
    }

    // PLR Items -- can't tell what isPlr even is...
    if (item.isPlr === true || (typeof item.isPlr === "function" && item.isPlr())) {
        var collab = el8.ptdata.plrCollaborators.getByPracticeId(item.getSourcePracticeId());
        var defaultMap = {
            feedItemId: item.getFeedItemId(),
            feedDate: el8.service.tz.soyStr(item.getChartFeedDate()),
            buttonsInfo: [],
            sharerName: collab ? collab.getPhysicianName() : '',
            lastReviewTime: el8.service.tz.soyStr(el8.appchart.mainFeeds.plrNotification.getLastReviewTime()),
            item: item.asSoyMap(),
            sortByProviderActivity: item.sortByProviderActivity
        };

        switch (mClass) {
            case "Report":
                return function(item, feedId, indexItem) {
                    defaultMap.feedId = feedId;
                    defaultMap.report = item.asSoyMap(['resultGrids']);
                    return _templateBase.plr.reportItem(defaultMap);
                };
            case "VisitNote":
                return function(item, feedId) {
                    defaultMap.feedId = feedId;
                    defaultMap.typeName = item.asSoyMap().type.name;
                    defaultMap.reason =_(item.asSoyMap().reasonBullets).map(function(b) { return b.text; }).join('; ');
                    return _templateBase.plr.visitNoteItem(defaultMap);
                };
            case "NonvisitNote":
                return function(item, feedId) {
                    defaultMap.feedId = feedId;
                    defaultMap.textPreview = _(item.getCamelJson().bullets).map(function(b) { return b.text; }).join('; ');
                    return _templateBase.plr.nonvisitNoteItem(defaultMap);
                };
            case "LabOrder":
            case "ImagingOrder":
            case "SleepOrder":
            case "CardiacOrder":
            case "PulmonaryOrder":
            case "ReferralOrder":
                return function(item, feedId) {
                    defaultMap.feedId = feedId;
                    defaultMap.order = item.asSoyMap();
                    return _templateBase.plr.orderItem(defaultMap);
                };
            default:
                var msg = 'Unexpected PLR model class: ' + mClass + '; item id: ' + item.getId();
                UIM && UIM.logError(msg);
                return null;
        }

    // Items my practice owns
    } else {
        var getLabResultsForFeed = function(reportType, item) {
            if (reportType !== "lab") { return null; }

            var magicTableData = el8.appchart.mainFeeds.chart.getMagicTableData();
            if (magicTableData && magicTableData.test_ids) {
                var results = [];
                var resultRows = item.getResultsForTestIds(magicTableData.test_ids);
                for (var i=0; i < resultRows.length; i++) {
                    results.push(
                        {
                            labTest: resultRows[i].getLabTest().getName(),
                            value: resultRows[i].getValue(),
                            units: resultRows[i].getUnits(),
                            documentingPersonnelType: resultRows[i].getDocumentingPersonnelType()
                        });
                }
                return results;
            } else {
                return null;
            }
        };

        var collab;
        if (item.getSourcePracticeId) {
            collab = el8.ptdata.plrCollaborators.getByPracticeId(item.getSourcePracticeId());
        }
        var defaultMap = {
            feedItemId: item.getFeedItemId(),
            feedDate: el8.service.tz.soyStr(item.getChartFeedDate()),
            buttonsInfo: el8.appchart.mainFeeds.actions.buttons(item),
            sharerName: collab ? collab.getPhysicianName() : '',
            sortByProviderActivity: item.sortByProviderActivity
        };

        switch (mClass) {
            case "Report":
                return function(item, feedId, indexItem) {
                  return _templateBase.reportItem(
                    $.extend(defaultMap, {
                      feedId: feedId,
                      indexItem: indexItem,
                      report: item.asSoyMap(),
                      referringThreads: item
                        .getReferringThreads()
                        .map(el8.model.toSoyMapFn),
                      labResults: getLabResultsForFeed(item.getReportType(), item),
                      currUserId: el8.data.currUser.getId()
                    })
                  );
                };
            case "DenialMedOrder":
                return function(item, feedId) {
                    return _templateBase.denialMedOrder($.extend(defaultMap, {
                        feedId: feedId,
                        item: item.asSoyMap()
                    }));
                };
            case "LabOrder":
            case "ImagingOrder":
            case "SleepOrder":
            case "CardiacOrder":
            case "PulmonaryOrder":
            case "ReferralOrder":
                return function(item, feedId) {
                    return _templateBase.orderItem($.extend(defaultMap, {
                        feedId: feedId,
                        order: item.asSoyMap(),
                        currUserId: el8.data.currUser.getId()
                        // isCurrUserOrderDelegateOfSigner: _.contains(el8.data.currUser.getOrderDelegatingPhysicianIds(), item.getSignUserId())
                    }));
                };

            case "MedOrder":
                return function(item, feedId) {
                    return _templateBase.medOrderItem($.extend(defaultMap, {
                        feedId: feedId,
                        order: $.extend(item.asSoyMap(), {
                            feedItemId : item.getFeedItemId(),
                            isWrittenOnStartDate: el8.util.datecompare.isSameDay(item.getChartFeedDate(), item.getStartDate())
                        }),
                        hasActions: true
                    }));
                };
            case "DiscontinueMedOrder":
                return function(item, feedId) {
                    return _templateBase.dcMedOrderItem($.extend(defaultMap, {
                        feedId: feedId,
                        order: $.extend(item.asSoyMap(), {
                            feedItemId : item.getFeedItemId(),
                            medicationName : item.getDisplayedMedicationName()
                        }),
                        hasActions: true,
                        currUserId: el8.data.currUser.getId()
                    }));
                };
            case "NonvisitNote":
                return function(item, feedId) {
                    var obj = el8.ptdata.model.note.asSoyMap(item);
                    $.extend(defaultMap, obj, {
                        feedId: feedId,
                        signUserId: item.getSignUserId(),
                        currUserId: el8.data.currUser.getId()
                    });

                    if (item.isImportedNote()) {
                        return _templateBase.importedNote(defaultMap);
                    } else {
                        return _templateBase.nonvisitNote(defaultMap);
                    }
                };
            case "MessageThread":
                return function(item, feedId) {
                    var inChart = (el8Globals['APP'] === 'chart');
                    var soyMap = item.asSoyMap(inChart);
                    $.extend(defaultMap, soyMap, {
                        feedId : feedId,
                        currUserId: el8.data.currUser.getId(),
                        useNewMessages: el8Globals.FEATURES.NewOfficeMessages
                    });

                    return _templateBase.messageThread(defaultMap);
                };
            case "VisitNote":
                return function(item, feedId) {
                    var obj = el8.ptdata.model.note.asSoyMap(item);
                    $.extend(defaultMap, obj, {
                        feedId : item.isPreview() ? 'preview_'+feedId : feedId,
                        isAmendPreview: Boolean(item.getCurrentEditId() && item.isPreview()),
                        showMuInfo: el8Globals['FEATURES']['MUReports'],
                        currUserId: el8.data.currUser.getId()
                    });
                    // Assessment section also needs feedItemId
                    obj.assessment['feedItemId'] = item.getFeedItemId();

                    if (item.isImportedNote()) {
                        // The default map uses the documentDate, but this is more like
                        // a report, where the chart date = date of import
                        defaultMap['feedDate'] = el8.service.tz.soyStr(item.getChartFeedDate());
                        return _templateBase.importedNote(defaultMap);
                    } else {
                        return _templateBase.visitNote(defaultMap);
                    }
                };
            case "RxHistoryDownloadSummary":
                return function(item, feedId) {
                    var result = _templateBase.rxHistoryDownload($.extend(defaultMap, {
                        feedId: feedId,
                        summaryItem: item.asSoyMap()
                    }));
                    return result;
                };

            case "Letter":
                return function(letter, feedId) {
                    var soyMap = letter.asSoyMap();
                    return convertLinks(_templateBase.letterItem($.extend(defaultMap, {
                        feedId: feedId,
                        patient: el8.ptdata.currPatient.asSoyMap(),
                        letter: soyMap,
                        currUserId: el8.data.currUser.getId()
                    })));
                };
            case "LetterReceipt":
                return function(letterReceipt, feedId) {
                    return _templateBase.letterReceipt($.extend(defaultMap, {
                        feedId: feedId,
                        patient: el8.ptdata.currPatient.asSoyMap(),
                        letterReceipt: letterReceipt.asSoyMap(),
                        currUserId: el8.data.currUser.getId()
                    }));
                };
            case "UnreadLetterNotification":
                return function(unreadLetterNotification, feedId) {
                    var soyMap = unreadLetterNotification.asSoyMap();
                    return _templateBase.unreadLetterNotificationItem($.extend(defaultMap, {
                        feedId: feedId,
                        patient: el8.ptdata.currPatient.asSoyMap(),
                        unreadLetterNotification: soyMap,
                        letter: unreadLetterNotification.getLetter().asSoyMap(),
                        currUserId: el8.data.currUser.getId()
                    }));
                };
            case "XmlPatientSummary":
                return function(summary, feedId) {
                    return _templateBase.xmlSummaryItem($.extend(defaultMap, {
                        feedId: feedId,
                        summaryItem: summary.asSoyMap(),
                        currUserId: el8.data.currUser.getId()
                    }));
                };
            case "Hl7Message":
                return function(message, feedId) {
                    return _templateBase.hl7MessageItem($.extend(defaultMap, {
                        feedId: feedId,
                        messageItem: message.asSoyMap(),
                        currUserId: el8.data.currUser.getId()
                    }));
                };
            case "DocumentAddendum":
                return function(item, feedId, indexItem) {
                    return _templateBase.addendumItem($.extend(defaultMap, {
                        feedId: feedId,
                        indexItem: indexItem,
                        item: item.asSoyMap(),
                        referencedDoc: item.getReferencedDocumentId() ?
                            el8.ptdata.fetchById(item.getReferencedDocumentId()).asSoyMap() : null
                    }));
                };
            case "PatientCollaboratorNotification":
                return function(notification, feedId) {
                    return _templateBase.plrCollaboratorNotification($.extend(defaultMap, {
                        feedId: feedId,
                        item: notification.asSoyMap()
                    }));
                };
            case "DocumentReminderNotification":
                return function(documentReminderNotification, feedId) {
                    var soyMap = documentReminderNotification.asSoyMap();
                    return _templateBase.documentReminderNotificationItem($.extend(defaultMap, {
                        feedId: feedId,
                        patient: el8.ptdata.currPatient.asSoyMap(),
                        documentReminderNotification: soyMap,
                        currUserId: el8.data.currUser.getId()
                    }));
                };
            case "VipAccessNotification":
                return function(notification, feedId) {
                    return _templateBase.vipAccessNotification($.extend(defaultMap, {
                        feedId: feedId,
                        item: notification.asSoyMap()
                    }));
                };
            case "PmpCheckNotification":
                return function(notification, feedId) {
                    return _templateBase.pmpCheckNotification($.extend(defaultMap, {
                        feedId: feedId,
                        item: notification.asSoyMap()
                    }));
                };
            case "PrenatalFlowsheetVisitMeasurements":
                return function(prenatalFlowsheetVisitMeasurements, feedId) {
                    return _templateBase.prenatalFlowsheetVisitMeasurements($.extend(defaultMap, {
                        feedId: feedId,
                        visitMeasurements: prenatalFlowsheetVisitMeasurements.asSoyMap(),
                        flowsheet: prenatalFlowsheetVisitMeasurements.getFlowsheet().asSoyMap()
                    }));
                };
            default:
                return null;
        }
    }

};
